(function () {
  'use strict';
  var KEY = 'misu.privacy.optOut';
  var chosen = false;
  try { chosen = localStorage.getItem(KEY) === 'true'; } catch (_) {}
  function optedOut() { return chosen || navigator.globalPrivacyControl === true; }
  function privacy() { return window.Shopify && window.Shopify.customerPrivacy; }
  function allowed(kind) {
    if (optedOut()) return false;
    var api = privacy(), method = kind === 'marketing' ? 'marketingAllowed' : 'analyticsProcessingAllowed';
    return !!(api && typeof api[method] === 'function' && api[method]());
  }
  function clearTracking() {
    try {
      ['misu.popup.eventQueue','misu.popup.visitor','misu_mailroom_v1'].forEach(function (key) { localStorage.removeItem(key); });
      sessionStorage.removeItem('misu.popup.session');
    } catch (_) {}
  }
  function notify() {
    if (optedOut()) clearTracking();
    window.dispatchEvent(new CustomEvent('misu:privacy-changed'));
    var status = document.querySelector('[data-privacy-status]');
    if (status) status.textContent = navigator.globalPrivacyControl ? 'Global Privacy Control is on. Optional analytics and advertising sharing are disabled in this browser.' : optedOut() ? 'Your opt-out is saved. Optional analytics and advertising sharing are disabled in this browser.' : 'You can turn off optional analytics and advertising sharing below.';
  }
  function apply(callback) {
    var api = privacy();
    if (!api || typeof api.setTrackingConsent !== 'function') { if (callback) callback(false); return; }
    api.setTrackingConsent({analytics:false,marketing:false,sale_of_data:false}, function (result) {
      notify(); if (callback) callback(!(result && result.error));
    });
  }
  function loadApi() {
    if (privacy()) { if (optedOut()) apply(); notify(); return; }
    if (window.Shopify && typeof Shopify.loadFeatures === 'function') Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error) { if (!error && optedOut()) apply(); notify(); });
  }
  window.MisuPrivacy = {
    optedOut: optedOut,
    allowsAnalytics: function () { return allowed('analytics'); },
    allowsMarketing: function () { return allowed('marketing'); },
    optOut: function (callback) {
      chosen = true; try { localStorage.setItem(KEY,'true'); } catch (_) {}
      clearTracking(); notify(); apply(callback);
    }
  };
  if (optedOut()) clearTracking();
  document.addEventListener('visitorConsentCollected',notify);
  document.addEventListener('click',function(e) {
    var button = e.target.closest('[data-privacy-opt-out]'); if (!button) return;
    button.disabled = true;
    window.MisuPrivacy.optOut(function(ok) {
      button.disabled = false;
      if (!ok) document.querySelector('[data-privacy-status]').textContent = 'Your local opt-out is saved. Shopify could not confirm its update; please retry or email support@dailymisu.com for help.';
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',loadApi,{once:true}); else loadApi();
  window.addEventListener('load',loadApi,{once:true});
})();
